import React from 'react';
import { useSelector } from 'react-redux';

import {
  FILTER_GENERATION,
  FILTER_COAT,
  FILTER_TAIL,
  RESULTS_TYPE
} from 'dpl/constants/query_params';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import FilterDrawer from './FilterDrawer';
import MultiSelectFilter from './MultiSelectFilter';

export default function AttributesFilter() {
  const [{ breedGeneration, breedCoat, breedTail }, resultsType] = useSelector(
    ({ server, queryParams }) => [server, queryParams[RESULTS_TYPE]]
  );

  const isBreedersTabActive = resultsType === RESULTS_TYPES.BREEDERS;

  const attributeFilters = [
    breedGeneration.length > 0 && {
      label: 'Generation',
      filterValues: breedGeneration,
      tooltipText:
        'Generation refers to the percentage of each parent dog present in that specific litter.',
      filterParam: FILTER_GENERATION
    },
    breedCoat.length > 0 && {
      label: 'Coat Type',
      filterValues: breedCoat,
      filterParam: FILTER_COAT
    },
    breedTail.length > 0 &&
      isBreedersTabActive && {
        label: 'Tail Type',
        filterValues: breedTail,
        tooltipText:
          'Indicates whether or not a dog’s tail has been docked or is natural. For some dog breeds, tail docking, or removing a portion of a dog’s tail, is a standard practice.',
        filterParam: FILTER_TAIL
      }
  ].filter(Boolean);

  if (attributeFilters.length === 0) return null;

  return (
    <FilterDrawer
      className="BreederSearchResultsAttributesFilter"
      title="Attributes"
    >
      {attributeFilters.map(attributeFilter => {
        const { label, filterValues, tooltipText, filterParam } =
          attributeFilter;

        if (filterValues.length === 0) return null;

        return (
          <div key={label} className="pb4">
            <MultiSelectFilter
              filterValues={filterValues}
              label={label}
              filterParam={filterParam}
              filterTooltipText={tooltipText}
            />
          </div>
        );
      })}
    </FilterDrawer>
  );
}
